import { FunctionComponent } from "react";

import { useCampaignContext } from "@voxmedia/duet-context/context/campaign-context";
import { useGlobalDataContext } from "@voxmedia/duet-context/context/global-data-context";
import UIWikiBanner from "@voxmedia/duet-ui/components/navigation/WikiBanner/WikiBanner";

interface Props {
  template?: string;
  className?: string;
  isHomepage?: boolean;
}

const WikiBannerContainer: FunctionComponent<Props> = ({
  template,
  className,
  isHomepage,
}) => {
  const { wikiBanner, breakingNewsBanner } = useGlobalDataContext();
  const { campaign } = useCampaignContext();

  // Only show Wiki Banner if
  // - there is no campaign or Breaking News Banner
  // - there is a banner set
  if (campaign || breakingNewsBanner || !wikiBanner) {
    return null;
  }

  // On the homepage, only show if the banner is explicitly enabled for homepage
  if (isHomepage && !wikiBanner.showOnHomepage) {
    return null;
  }

  return (
    <UIWikiBanner
      className={className}
      template={template}
      wikiBanner={wikiBanner}
    />
  );
};

export default WikiBannerContainer;
